// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xqE8","questions":"styles_questions__1IuSF","footer":"styles_footer__228j8"};